import Main from "./components/main/Main";

import "./App.scss";

function App() {
  return <Main />;
}

export default App;
